var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import cTokens from '../../../../Fct/tokens/cTokens.json';
import { compoundTokens, isNative } from '../constants';
export var RepayBorrow = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'ACTION',
    method: 'repayBorrow',
    name: 'repayBorrow',
    description: 'Repay borrowed ERC20 tokens or ETH',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'ctoken',
                    options: compoundTokens.filter(function (token) { return token.chainId === Number(chainId); }),
                }),
                value: new FctValue({ destination: 'wei_amount', required: false, readonly: true }),
                amount: new FctValue({ destination: 'wei_amount' }),
                methodParams: {
                    repayAmount: new FctValue({ destination: 'wei_amount', required: false, readonly: true }),
                },
            },
            output: {},
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, chainId = _a.chainId;
        var getParamsAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
            var to, value, amount, methodParams;
            return __generator(this, function (_a) {
                to = input.to, value = input.value, amount = input.amount, methodParams = input.methodParams;
                if (!to.value || to.isVariable) {
                    return [2 /*return*/, {
                            params: { value: undefined, methodParams: { repayAmount: undefined } },
                            error: undefined,
                        }];
                }
                if (isNative(to.value, chainId)) {
                    value.value = amount.value;
                    methodParams.repayAmount.value = undefined;
                    methodParams.repayAmount.virtual = true;
                    methodParams.repayAmount.required = false;
                    value.required = true;
                    return [2 /*return*/, {
                            params: { value: amount.value },
                            error: undefined,
                        }];
                }
                methodParams.repayAmount.required = true;
                value.required = false;
                value.value = '0';
                methodParams.repayAmount.value = amount.value;
                methodParams.repayAmount.virtual = false;
                return [2 /*return*/, {
                        params: { value: undefined, methodParams: { repayAmount: amount.value } },
                        error: undefined,
                    }];
            });
        }); };
        return { get: getParamsAsync, depParamKeys: ['to', 'amount'] };
    },
    requiredApprovals: function (params, chainId) {
        var _a;
        if (!params.to.value)
            return [];
        if (isNative(params.to.value, chainId))
            return [];
        var underlyingToken = (_a = cTokens.find(function (cToken) {
            if (typeof (params === null || params === void 0 ? void 0 : params.to.value) === 'string' && cToken.address.toLowerCase() === (params === null || params === void 0 ? void 0 : params.to.value.toLocaleLowerCase()))
                return true;
            return false;
        })) === null || _a === void 0 ? void 0 : _a.assetAddress;
        return [
            {
                to: underlyingToken,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params.methodParams.repayAmount.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var _a;
        var to = params.to, amount = params.amount;
        if (!amount.value || !to.value || !vaultAddress)
            return [];
        if (typeof amount.value !== 'string' || typeof to.value !== 'string')
            return [];
        // Find asset from cToken address
        var asset = (to === null || to === void 0 ? void 0 : to.value) && ((_a = compoundTokens.find(function (token) { return token.address === to.value; })) === null || _a === void 0 ? void 0 : _a.assetAddress);
        if (!asset)
            return [];
        return [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: asset,
                        amount: amount.value,
                    },
                ],
                toReceive: [],
            },
            {
                address: to.value,
                toSpend: [],
                toReceive: [
                    {
                        token: asset,
                        amount: amount.value,
                    },
                ],
            },
        ];
    },
});
